class ChangeHistoryFilterMap {
  constructor() {
    // @ts-ignore
    this.map = new Map();
    // @ts-ignore
    this.map.set("processCategory", "ProcessCategory");
    // @ts-ignore
    this.map.set("triggerProcess", "TriggerProcess");
    // @ts-ignore
    this.map.set("processStatus", "ProcessStatus");
    // @ts-ignore
    this.map.set("processInitiateDate", "ProcessInitiateDate");
    // @ts-ignore
    this.map.set("processInitiator", "ProcessInitiator");
    // @ts-ignore
    this.map.set("currentProcessor", "CurrentProcessor");
    // @ts-ignore
    this.map.set("processCompletedDate", "ProcessCompletedDate");
  }

  set(key: any, value: any) {
    // @ts-ignore
    this.map.set(key, value);
  }

  get(key: any) {
    // @ts-ignore
    return this.map.get(key);
  }
}

const changeHistoryFilterMap = new ChangeHistoryFilterMap();

export default changeHistoryFilterMap;
